import { BsMetaUtil } from "@bridgesplit/abf-react";
import { TokenPositionExpanded } from "@bridgesplit/abf-sdk";
import { StatProps } from "@bridgesplit/ui";
import { formatPercent } from "@bridgesplit/utils";
import { HealthChange } from "app/components/common";

import { useRaydiumLtv } from "../raydium/util";
import { useWhirlpoolLtv } from "../whirlpool/util";

export function useTokenAmountStats({
    tokenAChange,
    tokenBChange,
    tokenA,
    tokenB
}: {
    tokenAChange: number;
    tokenBChange: number;
    tokenA: TokenPositionExpanded;
    tokenB: TokenPositionExpanded;
}): StatProps[] {
    return [
        {
            caption: BsMetaUtil.getSymbol(tokenA.metadata),
            value: [
                BsMetaUtil.formatAmount(tokenA.metadata, tokenA.amount, { hideSymbol: true }),
                BsMetaUtil.formatAmount(tokenA.metadata, tokenA.amount + tokenAChange, { hideSymbol: true })
            ]
        },
        {
            caption: BsMetaUtil.getSymbol(tokenB.metadata),
            value: [
                BsMetaUtil.formatAmount(tokenB.metadata, tokenB.amount, { hideSymbol: true }),
                BsMetaUtil.formatAmount(tokenB.metadata, tokenB.amount + tokenBChange, { hideSymbol: true })
            ]
        }
    ];
}

type HealthChangeType = ReturnType<typeof useRaydiumLtv> | ReturnType<typeof useWhirlpoolLtv>;

export function useHealthChangeStats(data: HealthChangeType): StatProps[] {
    const { originalHealth, newHealth } = data;

    return [
        {
            caption: "LTV",
            value:
                originalHealth.ltv !== newHealth.ltv
                    ? [formatPercent(originalHealth.ltv), formatPercent(newHealth.ltv)]
                    : formatPercent(newHealth.ltv)
        },
        {
            caption: "Health",
            value: <HealthChange originalHealth={originalHealth} newHealth={newHealth} />
        }
    ];
}
